export const SubscriptionConstants = {
  SUBSCRIPTION_CLIENT_ID: 'cf_subscription_client_id',
  BILLING_EMAIL: 'cf_billing_email',
};
